/* eslint-disable react/display-name */
import React, { useState } from 'react'
import NewCopyIcon from '../../../components/icons/newCopy'
import { copyToClipboard } from '../../../utils/copyToClipboard'
import { CheckmarkBackgroundIcon } from '@paypalcorp/pp-react'

import './new-code-blocks-wrapper.css'

export default ({ children }: any) => {
  const fptiData = typeof window !== `undefined` && window.fpti
  const gaData = typeof window !== `undefined` && window.ga
  const [isCopied, setIsCopied] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleCopyClipboard = () => {
    copyToClipboard(children.props.children)
    setLoading(true)

    setTimeout(() => {
      setLoading(false)
      setIsCopied(true)
    }, 2000)

    setTimeout(() => {
      setIsCopied(false)
    }, 4000)

    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          e: 'cl',
          link: 'copy-content',
          component: 'devdiscoverynodeweb',
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.record(options)
      }
    }

    if (gaData) {
      gaData('send', 'event', {
        eventCategory: 'codeblock',
        eventAction: 'click',
        eventLabel: 'copyContent',
      })
    }
  }

  return (
    <div className="new-codeBlocks-wrapper">
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          marginBottom: '22px',
          height: '40px',
        }}
      >
        <div onClick={() => handleCopyClipboard()}>
          {loading && <div className="loader" />}
          {isCopied && (
            <CheckmarkBackgroundIcon
              size="lg"
              className="checkmark-bg-icon"
              color="sysColorAccent3Main"
            />
          )}
          {!loading && !isCopied && <NewCopyIcon />}
        </div>
      </div>
      {children}
    </div>
  )
}
